import { createAction, createAsyncAction } from 'typesafe-actions';

export const getSampleAsyncAction = createAsyncAction(
    '@bs/GET_SAMPLE_REQUEST [CMD]',
    '@bs/GET_SAMPLE_SUCCESS [CMD]',
    '@bs/GET_SAMPLE_FAILURE [EVENT]'
)<undefined, readonly string[], Error>();

export const getSampleSuccess = createAction('@bs/GET_SAMPLE_SUCCESS [DOC]')();
